// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateAlertDestinationMutationVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  name: Types.Scalars["String"]["input"];
  integrations?: Types.InputMaybe<
    | Array<Types.AlertDestinationIntegrationInput>
    | Types.AlertDestinationIntegrationInput
  >;
  memberIds?: Types.InputMaybe<
    Array<Types.Scalars["ID"]["input"]> | Types.Scalars["ID"]["input"]
  >;
}>;

export type CreateAlertDestinationMutation = {
  __typename?: "Mutation";
  createAlertDestination?: {
    __typename?: "AlertDestination";
    id: string;
    name: string;
  } | null;
};

export type UpdateAlertDestinationMutationVariables = Types.Exact<{
  alertDestinationId: Types.Scalars["ID"]["input"];
  name?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  integrations?: Types.InputMaybe<
    | Array<Types.AlertDestinationIntegrationInput>
    | Types.AlertDestinationIntegrationInput
  >;
  memberIds?: Types.InputMaybe<
    Array<Types.Scalars["ID"]["input"]> | Types.Scalars["ID"]["input"]
  >;
}>;

export type UpdateAlertDestinationMutation = {
  __typename?: "Mutation";
  updateAlertDestination?: {
    __typename?: "AlertDestination";
    id: string;
  } | null;
};

export type DeleteAlertDestinationMutationVariables = Types.Exact<{
  alertDestinationId: Types.Scalars["ID"]["input"];
}>;

export type DeleteAlertDestinationMutation = {
  __typename?: "Mutation";
  deleteAlertDestination?: {
    __typename?: "AlertDestination";
    id: string;
  } | null;
};

export type LeaveAlertDestinationMutationVariables = Types.Exact<{
  alertDestinationId: Types.Scalars["ID"]["input"];
}>;

export type LeaveAlertDestinationMutation = {
  __typename?: "Mutation";
  leaveAlertDestination?: {
    __typename?: "AlertDestination";
    id: string;
  } | null;
};

export const CreateAlertDestinationDocument = gql`
  mutation CreateAlertDestination(
    $organizationSlug: ID!
    $name: String!
    $integrations: [AlertDestinationIntegrationInput!]
    $memberIds: [ID!]
  ) {
    createAlertDestination(
      organizationSlug: $organizationSlug
      name: $name
      integrations: $integrations
      memberIds: $memberIds
    ) {
      id
      name
    }
  }
`;
export type CreateAlertDestinationMutationFn = Apollo.MutationFunction<
  CreateAlertDestinationMutation,
  CreateAlertDestinationMutationVariables
>;

/**
 * __useCreateAlertDestinationMutation__
 *
 * To run a mutation, you first call `useCreateAlertDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlertDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlertDestinationMutation, { data, loading, error }] = useCreateAlertDestinationMutation({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      name: // value for 'name'
 *      integrations: // value for 'integrations'
 *      memberIds: // value for 'memberIds'
 *   },
 * });
 */
export function useCreateAlertDestinationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAlertDestinationMutation,
    CreateAlertDestinationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAlertDestinationMutation,
    CreateAlertDestinationMutationVariables
  >(CreateAlertDestinationDocument, options);
}
export type CreateAlertDestinationMutationHookResult = ReturnType<
  typeof useCreateAlertDestinationMutation
>;
export type CreateAlertDestinationMutationResult =
  Apollo.MutationResult<CreateAlertDestinationMutation>;
export type CreateAlertDestinationMutationOptions = Apollo.BaseMutationOptions<
  CreateAlertDestinationMutation,
  CreateAlertDestinationMutationVariables
>;
export const UpdateAlertDestinationDocument = gql`
  mutation UpdateAlertDestination(
    $alertDestinationId: ID!
    $name: String
    $integrations: [AlertDestinationIntegrationInput!]
    $memberIds: [ID!]
  ) {
    updateAlertDestination(
      alertDestinationId: $alertDestinationId
      name: $name
      integrations: $integrations
      memberIds: $memberIds
    ) {
      id
    }
  }
`;
export type UpdateAlertDestinationMutationFn = Apollo.MutationFunction<
  UpdateAlertDestinationMutation,
  UpdateAlertDestinationMutationVariables
>;

/**
 * __useUpdateAlertDestinationMutation__
 *
 * To run a mutation, you first call `useUpdateAlertDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlertDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlertDestinationMutation, { data, loading, error }] = useUpdateAlertDestinationMutation({
 *   variables: {
 *      alertDestinationId: // value for 'alertDestinationId'
 *      name: // value for 'name'
 *      integrations: // value for 'integrations'
 *      memberIds: // value for 'memberIds'
 *   },
 * });
 */
export function useUpdateAlertDestinationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAlertDestinationMutation,
    UpdateAlertDestinationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAlertDestinationMutation,
    UpdateAlertDestinationMutationVariables
  >(UpdateAlertDestinationDocument, options);
}
export type UpdateAlertDestinationMutationHookResult = ReturnType<
  typeof useUpdateAlertDestinationMutation
>;
export type UpdateAlertDestinationMutationResult =
  Apollo.MutationResult<UpdateAlertDestinationMutation>;
export type UpdateAlertDestinationMutationOptions = Apollo.BaseMutationOptions<
  UpdateAlertDestinationMutation,
  UpdateAlertDestinationMutationVariables
>;
export const DeleteAlertDestinationDocument = gql`
  mutation DeleteAlertDestination($alertDestinationId: ID!) {
    deleteAlertDestination(alertDestinationId: $alertDestinationId) {
      id
    }
  }
`;
export type DeleteAlertDestinationMutationFn = Apollo.MutationFunction<
  DeleteAlertDestinationMutation,
  DeleteAlertDestinationMutationVariables
>;

/**
 * __useDeleteAlertDestinationMutation__
 *
 * To run a mutation, you first call `useDeleteAlertDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlertDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlertDestinationMutation, { data, loading, error }] = useDeleteAlertDestinationMutation({
 *   variables: {
 *      alertDestinationId: // value for 'alertDestinationId'
 *   },
 * });
 */
export function useDeleteAlertDestinationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAlertDestinationMutation,
    DeleteAlertDestinationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteAlertDestinationMutation,
    DeleteAlertDestinationMutationVariables
  >(DeleteAlertDestinationDocument, options);
}
export type DeleteAlertDestinationMutationHookResult = ReturnType<
  typeof useDeleteAlertDestinationMutation
>;
export type DeleteAlertDestinationMutationResult =
  Apollo.MutationResult<DeleteAlertDestinationMutation>;
export type DeleteAlertDestinationMutationOptions = Apollo.BaseMutationOptions<
  DeleteAlertDestinationMutation,
  DeleteAlertDestinationMutationVariables
>;
export const LeaveAlertDestinationDocument = gql`
  mutation LeaveAlertDestination($alertDestinationId: ID!) {
    leaveAlertDestination(alertDestinationId: $alertDestinationId) {
      id
    }
  }
`;
export type LeaveAlertDestinationMutationFn = Apollo.MutationFunction<
  LeaveAlertDestinationMutation,
  LeaveAlertDestinationMutationVariables
>;

/**
 * __useLeaveAlertDestinationMutation__
 *
 * To run a mutation, you first call `useLeaveAlertDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveAlertDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveAlertDestinationMutation, { data, loading, error }] = useLeaveAlertDestinationMutation({
 *   variables: {
 *      alertDestinationId: // value for 'alertDestinationId'
 *   },
 * });
 */
export function useLeaveAlertDestinationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LeaveAlertDestinationMutation,
    LeaveAlertDestinationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    LeaveAlertDestinationMutation,
    LeaveAlertDestinationMutationVariables
  >(LeaveAlertDestinationDocument, options);
}
export type LeaveAlertDestinationMutationHookResult = ReturnType<
  typeof useLeaveAlertDestinationMutation
>;
export type LeaveAlertDestinationMutationResult =
  Apollo.MutationResult<LeaveAlertDestinationMutation>;
export type LeaveAlertDestinationMutationOptions = Apollo.BaseMutationOptions<
  LeaveAlertDestinationMutation,
  LeaveAlertDestinationMutationVariables
>;
